import TomSelect from "tom-select"

const DEFAULT_SETTINGS = {
    create: false,
    sortField: {
        field: "text",
        direction: "asc"
    },
    maxOptions: null // tom-select will truncate the select to 50 options by default
};

/**
 * Initialize TomSelect on an element by id with the default settings.
 *
 * If the element already has a TomSelect instance attached, that instance is
 * destroyed and re-created so the caller always gets a TomSelect with the
 * current default settings (a previous call with different settings would
 * otherwise leave stale config in place).
 */
export function tom_select_with_id(id) {
    const select = document.getElementById(id);
    if (!select) return;

    if (select.tomselect) {
        select.tomselect.destroy();
    }

    new TomSelect(select, DEFAULT_SETTINGS);
}
